import React from "react";
import useSWR from "swr";
import api, { API_BASE } from "@/lib/api";
import { gbp, ddmmyyyy } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, Download } from "lucide-react";

const fetcher = (url) => api.get(url).then((r) => r.data);

const statusColor = {
  draft: "bg-slate-100 text-slate-700",
  approved: "bg-blue-100 text-blue-700",
  paid: "bg-emerald-100 text-emerald-700",
};

const DriverInvoices = () => {
  const { data, isLoading } = useSWR("/invoices", fetcher);

  return (
    <div className="p-4 pt-6">
      <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-mono">Invoices</div>
      <h1 className="font-heading text-2xl font-bold tracking-tight text-brand-text mt-1">Your invoices</h1>

      {isLoading && <div className="mt-4 text-sm text-slate-500">Loading…</div>}

      <div className="mt-4 space-y-3" data-testid="driver-invoices-list">
        {(data || []).map((inv) => (
          <Card key={inv.id} className="p-4 rounded-xl border-brand-border" data-testid={`driver-inv-${inv.number}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="font-heading font-bold text-brand-text text-sm font-mono">{inv.number}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">{inv.period_name}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">Pays {ddmmyyyy(inv.payment_date)}</div>
              </div>
              <div className="text-right">
                <div className="font-heading text-xl font-bold text-brand-text">{gbp(inv.net_pay)}</div>
                <Badge variant="outline" className={`text-[10px] uppercase tracking-wider mt-1 ${statusColor[inv.status] || ""}`}>
                  {inv.status}
                </Badge>
              </div>
            </div>
            <Button
              size="sm" variant="outline" className="w-full mt-3"
              onClick={() => window.open(`${API_BASE}/invoices/${inv.id}/pdf`, "_blank")}
              data-testid={`driver-inv-pdf-${inv.number}`}
            >
              <Download className="w-3.5 h-3.5 mr-1.5" /> Download PDF
            </Button>
          </Card>
        ))}
        {!isLoading && (data || []).length === 0 && (
          <Card className="p-8 rounded-2xl border-brand-border text-center">
            <FileText className="w-8 h-8 mx-auto text-slate-300" />
            <div className="mt-3 font-heading font-bold text-brand-text">No invoices yet</div>
            <p className="text-xs text-slate-500 mt-1">Invoices appear here once the period closes.</p>
          </Card>
        )}
      </div>
    </div>
  );
};

export default DriverInvoices;
